module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10228.63014c93.jpg";